import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ShoppingBag, ArrowLeft } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';

const PaymentSuccess = () => {
  const { clearCart } = useCart();

  // Clear the cart once when the success page mounts.
  // Also explicitly wipe localStorage keys in case the context is stale
  // (user arrived via external 3D Secure redirect, React state may be fresh).
  useEffect(() => {
    try {
      clearCart();
    } catch (e) {
      console.warn('clearCart error:', e);
    }
    // Belt-and-suspenders: clear known localStorage cart keys directly
    try {
      localStorage.removeItem('cart');
      localStorage.removeItem('cartItems');
      localStorage.removeItem('shopping_cart');
    } catch (e) {
      // ignore storage errors
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-500" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Ödeme Başarılı!
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-2">
          Ödemeniz başarıyla tamamlandı.
        </p>
        <p className="text-gray-500 text-sm mb-8">
          Siparişiniz işleme alındı. Sipariş onay e-postası kısa süre içinde e-posta adresinize gönderilecektir.
        </p>

        {/* Status Badge */}
        <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-3 mb-8">
          <p className="text-green-700 text-sm font-medium">
            ✓ Siparişiniz işleme alındı
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <Link
            to="/order-history"
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <ShoppingBag className="w-5 h-5" />
            Siparişlerimi Görüntüle
          </Link>
          <Link
            to="/"
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-xl transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Alışverişe Dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
